/* @flow */
// typecheck: ignore file
import React from 'react';
import Dialog from 'components/Dialog.jsx';
import RSVPFlow from 'payments/components/RSVPFlow.jsx';
import Activity from 'entities/Activity';
import PaymentViewSideInformation from 'payments/components/PaymentViewSideInformation.jsx';
import type {Attendance} from 'entities/ActivityRecipient'; // eslint-disable-line
import ActivityRecipient from 'entities/ActivityRecipient'; // eslint-disable-line

import './styles/RSVPDialog.scss';

type Props = {
  activity: Activity,
  isUnderage: boolean,
  initialRSVP?: ?Attendance,
  onRequestHide?: () => any, // injected prop, not actually optional
  activityRecipient?: ?ActivityRecipient,
  updateLocalActivityRecipient: (activityId: string, activityRecipient: ActivityRecipient) => void,
};

class RSVPDialog extends React.Component {
  props: Props;

  static childContextTypes = {
    isModal: React.PropTypes.bool,
    onRequestHide: React.PropTypes.func,
  }

  getChildContext() {
    return {
      isModal: true,
      onRequestHide: this.props.onRequestHide,
    };
  }

  onActivityRecipientUpdated = (recipient: ActivityRecipient) => {
    this.props.updateLocalActivityRecipient(this.props.activity.id, recipient);
  }

  render() {
    const {
      activity,
      isUnderage,
      initialRSVP,
      onRequestHide,
      activityRecipient,
      ...rest
    } = this.props;

    return (
      <Dialog
        eventScreenName="RSVPDialog"
        {...rest}
        size="xlarge"
        onRequestHide={onRequestHide}
        className="RSVPDialog">
        <div className="RSVPDialog-content">
          <div className="RSVPDialog-content-rsvp">
            <RSVPFlow
              activity={activity}
              isUnderage={isUnderage}
              initialRSVP={initialRSVP}
              initialActivityRecipient={activityRecipient}
              onActivityRecipientUpdated={this.onActivityRecipientUpdated}
            />
          </div>
          <div className="RSVPDialog-content-info">
            <PaymentViewSideInformation activity={activity} />
          </div>
        </div>
      </Dialog>
    );
  }
}

export default RSVPDialog;



// WEBPACK FOOTER //
// ./src/payments/components/RSVPDialog.jsx